import { Col, Row } from 'reactstrap'
import { McHeatMap } from '../../../components/Component'
import ForecastTable from './ForecastTable'
import React, { useMemo } from 'react'
import McPageHelpers from '../McPageHelpers'
import { useTranslation } from 'react-i18next'
import { useGlobalStoreData } from '../../../store/globalStore'
import { useForecastData } from '../../../store/rawStore'
import { Typography } from '@mui/material'

const ForecastItem = ({ id, hsCodeForecast }) => {
  const { t } = useTranslation()
  const forecast = useForecastData()
  const countriesGSD = useGlobalStoreData.countries()

  const forecastMapData = useMemo(() => {
    const hs = hsCodeForecast
    const list = hs?.countryForecasts ?? []
    if (!Array.isArray(list) || list.length === 0) return []
    return list.filter(cf => cf && cf.partnerCountryCode).map(cf => {
      const found = countriesGSD.find(c => c.countryId === cf.partnerCountryCode)
      let code = (found?.countryCode || cf.partnerCountryCode) || ''
      if (code === 'UK') code = 'GB'
      if (code === 'KV') code = 'XK'
      const val = Number(cf.predictionValue ?? 0)
      const valK = McPageHelpers.numDivisionByThousand(val)
      const pretty = McPageHelpers.numToLocaleString(val)
      const name = McPageHelpers.findCountryName(cf.partnerCountryCode)
      return {
        countryName: name,
        formatValue: pretty,
        value: valK,
        id: code,
        tooltipTxt: name + ': ' + pretty
      }
    })
  }, [forecast, countriesGSD, t])

  return (
    <div
      className="p-2 mb-3"
      style={{
        borderRadius: 20,
        border: '1px solid var(--mui-palette-divider, #e5e7eb)',
        background:
          'linear-gradient(180deg, rgba(255,255,255,0.95), rgba(255,255,255,0.9))',
        boxShadow:
          '0 1px 1px rgba(0,0,0,0.03), 0 8px 24px -12px rgba(2,132,199,0.25)'
      }}
    >
      <Row className="gy-3 gx-3">
        <Col md="12">
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              fontSize: 17,
              px: 2,
              py: 1,
              bgcolor: 'rgba(241,245,249,0.9)',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#1e293b'
            }}
          >{hsCodeForecast.hsCode} - {McPageHelpers.findCountryName(hsCodeForecast.selectedCountryCode)}</Typography>
        </Col>
        <Col md="5">
          <McHeatMap chartId={`forecast-${id}`} chartData={forecastMapData} code={`H-FO-${id + 1}`} height={400}/>
        </Col>
        <Col md="7">
          <ForecastTable data={hsCodeForecast}/>
        </Col>
      </Row>
    </div>)
}

export default ForecastItem
